export default __webpack_public_path__ + "static/media/teddy_sad_simple.97d9b9e0.svg";